import { Checkbox } from "../../../../../../styles/page";
import { usePosterContext } from "../../../../context/poster-context";
import { EditLine } from "../../styles";
import {
  MainInfoContentItemInput,
  MainInfoSectionItem,
  MainInfoSectionWrapper,
  MainInfoWrapper,
} from "../main-info/styles/main-info.style";

const Address = () => {
  const { showAddress, setShowAddress, address, setAddress } =
    usePosterContext();

  return (
    <MainInfoWrapper>
      <MainInfoSectionWrapper>
        <MainInfoSectionItem>
          <span>주소 및 연락처</span>
        </MainInfoSectionItem>
        <MainInfoSectionItem>
          <div className="label">포함여부</div>
          <Checkbox
            checked={showAddress}
            onChange={() => setShowAddress(!showAddress)}
          />
        </MainInfoSectionItem>
      </MainInfoSectionWrapper>
      <EditLine style={{ marginBottom: "30px" }} />
      <MainInfoContentItemInput
        disabled={!showAddress}
        value={address}
        onChange={(e) => setAddress(e.target.value)}
      />
    </MainInfoWrapper>
  );
};

export default Address;
